<file-manager [initialPath]="initialPath" [featureKey]="'COMPANY_OPERATIONS_FILE_MANAGER'"></file-manager>

